import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

export const PageShell = ({ children, title, overline, intro, image, testId }) => (
  <div className="min-h-screen bg-[#F4F4F4] flex flex-col" data-testid={testId}>
    <div className="relative bg-[#020165] am-grain overflow-hidden">
      {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />}
      <div className="absolute inset-0 bg-gradient-to-b from-[#020165]/70 to-[#020165]" />
      <div className="relative px-4 sm:px-6 lg:px-12 pt-4 pb-14 max-w-7xl mx-auto">
        <SiteHeader />
        {title && (
          <div className="mt-12 max-w-3xl am-rise">
            {overline && <p className="font-display text-xs uppercase tracking-[0.2em] font-bold text-[#F86900]">{overline}</p>}
            <h1 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight leading-[1.08] text-white" data-testid="page-title">{title}</h1>
            {intro && <p className="mt-4 text-white/75 text-base md:text-lg leading-relaxed">{intro}</p>}
          </div>
        )}
      </div>
    </div>
    <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 md:py-14">{children}</main>
    <div className="px-4 sm:px-6 lg:px-12 pb-4 max-w-7xl mx-auto w-full"><SiteFooter /></div>
  </div>
);
